import graphql from "babel-plugin-relay/macro";

const AllNotificationsQuery = graphql`
query AllNotificationsQuery{
   userNotification{
    edges{
      node{
        created
        edited
        id
        user {
          id
        }
        content
        icon
        category
        isRead
      }
    }
  }
}
`

export default AllNotificationsQuery;
